<template>
  <div id="app" class="product-single-container product-single-default mb-0">
    <div class="row">
      <div class="col-md-5">
        <div class="product-single-details mb-0">
          <h1 class="product-title border-bottom">{{ auction.title }}</h1>

          <div class="price-box mb-0">
            <span class="h4 text-muted font-weight-light">Original price:</span>
            <span class="h4 old-price">{{
              auction.originalPrice | formatDollars
            }}</span>
          </div>
          <div class="price-box mb-0">
            <span class="h4 text-muted font-weight-light">
              {{
                auction.status === "Scheduled"
                  ? "Starting price"
                  : "Auction started at"
              }}:</span
            >
            <span class="h4">{{ auction.startingPrice | formatDollars }}</span>
          </div>
          <div class="price-box mb-0">
            <span class="h4 text-muted font-weight-light mb-0"
              >Estimated sale price:</span
            >
            <span class="h4 mb-0" style="color: rgb(255, 140, 0)">{{
              auction.estimatedSale | formatDollars
            }}</span>
          </div>
          <div
            class="price-box mb-0 badge bg-success text-white"
            v-if="auction.status === 'Completed' && !!auction.winner"
          >
            <span class="h4 font-weight-light text-white">Sold at:</span>
            <span class="h3 text-white">
              {{ auction.winner.bid_amount_cents | formatDollars }} </span
            ><span class="h5 font-weight-light text-white"
              >on {{ auction.winner.bid_date | formatDateTime }}</span
            >
          </div>
        </div>
      </div>
      <div class="col-md-7">
        <div v-if="auction.status === 'Scheduled'" class="h3 text-center mb-0">
          <vac
            :end-time="auction.start_time"
            ref="auctionCountdown"
            :key="auctionCountdownKey"
          >
            <span slot="process" slot-scope="{ timeObj }">
              <span class="d-flex justify-content-center align-items-start">
                <span class="p-2">Auction starts in</span>
                <div class="d-flex flex-column">
                  <span
                    class="auction-countdown-box d-flex justify-content-center d-flex align-items-center ml-3"
                    :class="countdownStyle(timeObj.ceil.s)"
                    >{{
                      timeObj.d > 0
                        ? `${timeObj.d} Day${timeObj.d == 1 ? "" : "s"} ${
                            timeObj.h
                          }:${timeObj.m}:${timeObj.s}`
                        : `${timeObj.h}:${timeObj.m}:${timeObj.s}`
                    }}</span
                  ><span class="h4">
                    {{ auction.start_time | formatDateTime }}
                  </span>
                </div></span
              >
              <div>
                <span class="h4">Number of Bidders</span
                ><span class="h4" :class="countdownTextStyle(timeObj.ceil.s)">
                  {{ auction.filledSeats }} of {{ auction.targetSeats }}
                  <i
                    v-if="auction.filledSeats >= auction.targetSeats"
                    class="fas fa-check text-success"
                  ></i>
                </span>
              </div>
            </span>
            <span slot="finish"
              ><span class="auction-countdown-box" :class="countdownStyle(0)"
                >Auction Starting <i class="fas fa-spinner fa-spin"></i></span
            ></span>
          </vac>
        </div>
        <div v-else-if="auction.status === 'InProgress'">
          <h4 class="text-center text-dark">
            Current Auction Round: {{ auction.current_round }}
          </h4>
          <div class="d-flex justify-content-center">
            <div>
              <div class="d-flex align-items-center">
                <div class="price-box mb-0 p-2" ref="currentPrice">
                  <span class="mr-3 h3 text-muted font-weight-light"
                    >Current Bidding Price:</span
                  ><span class="h4 text-danger">{{
                    auction.current_round_price | formatDollars
                  }}</span>
                </div>
                <form
                  v-if="authenticated && seats.map(s => s.bidder_id).includes(userId)"
                  method="post"
                  :action="'/auctions/' + auction.id + '/seat/-1/accept'"
                  class="m-0 ml-5"
                  name="confirm-current-price"
                  :data-title="`Accept current price of ${this.$options.filters.formatDollars(
                    auction.current_round_price
                  )}?`"
                  data-noicon="true"
                >
                  <input type="hidden" name="_token" :value="getCsrfToken()" />
                  <button type="submit" class="btn btn-sm p-1 btn-info">
                    Accept at {{ auction.current_round_price | formatDollars }}
                  </button>
                </form>
              </div>
              <div class="price-box mb-0 p-2">
                <span class="mr-3 h4 text-muted font-weight-light"
                  >Next Round Price will be:</span
                ><span class="h5 text-success">{{
                  auction.next_round_price | formatDollars
                }}</span>
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="auction.status === 'Completed'">
          <h3 class="text-center">Auction completed</h3>
        </div>
        <div v-else-if="auction.status === 'Canceled'">
          <h3 class="text-center">Auction canceled</h3>
        </div>
      </div>
    </div>
    <hr class="mb-1 mt-0" />
    <div class="row">
      <div class="col-md-5 product-single-gallery mb-0 h-100">
        <form
          v-if="authenticated"
          method="post"
          class="m-0 p-0 text-right favorite-container"
          :action="'/auctions/' + auction.id + '/watch'"
        >
          <input type="hidden" name="_token" :value="getCsrfToken()" />

          <button
            v-if="auction.isWatchingAuction"
            class="btn btn-link m-0 p-0"
            type="submit"
          >
            <i
              class="fas fa-heart fa-2x text-danger round-bg-white"
              data-toggle="tooltip"
              title="You are curently watching this auction"
            ></i>
          </button>
          <button v-else class="btn btn-link m-0 p-0" type="submit">
            <i
              class="far fa-heart fa-2x text-danger round-bg-white"
              data-toggle="tooltip"
              title="Click to watch auction"
            ></i>
          </button>
        </form>
        <div class="product-slider-container">
          <div class="product-single-carousel owl-carousel owl-theme">
            <div
              class="product-item"
              v-for="photo in auction.photos"
              v-bind:key="photo.url"
            >
              <img
                class="product-single-image"
                :src="photo.preview"
                :data-zoom-image="photo.url"
              />
            </div>
          </div>
          <!-- End .product-single-carousel -->
          <span class="prod-full-screen">
            <i class="icon-plus"></i>
          </span>
        </div>
        <div class="prod-thumbnail owl-dots" id="carousel-custom-dots">
          <div
            class="owl-dot"
            v-for="photo in auction.photos"
            v-bind:key="photo.url"
          >
            <img :src="photo.thumbnail" />
          </div>
        </div>
      </div>
      <!-- End .product-desc -->
      <div id="auctionSeats" class="col-md-7 product-single-details my-0">
        <div class="alert alert-info" role="alert" v-if="!authenticated">
          You must
          <a href="/login">sign in</a>
          before you can purchase an auction seat.
        </div>

        <span class="text-muted small font-weight-bold">
          Click below and purchase a seat to be able to put your bid
        </span>

        <div class="seats-list" style="overflow: hidden auto">
          <auction-seat
            v-for="seat in seats"
            v-bind:key="seat.id"
            v-bind:seat="seat"
            v-bind:auction="auction"
          ></auction-seat>
          <div
            class="card text-white bg-dark mb-0"
            v-if="
              auction.additionalSeatPurchasable &&
              auction.status !== 'Completed' &&
              auction.status !== 'Canceled' &&
              seats.every(function (seat) {
                return !!seat.bidder_id;
              })
            "
          >
            <div class="card-body p-1">
              <div class="row d-flex align-items-center">
                <div class="col d-flex align-items-center">
                  <small class="mr-3" style="min-width: 12px">{{
                    seats[seats.length - 1].number + 1
                  }}</small>
                  <form
                    v-if="authenticated"
                    method="post"
                    :action="'/auctions/' + auction.id + '/seat/-1'"
                    class="form-horizontal m-0"
                    name="purchase-seat"
                    data-title="Confirm Auction Seat Purchase"
                    :data-text="`You are purchasing a seat for ${this.$options.filters.formatNumber(
                      seats[seats.length - 1].tokenPrice
                    )} tokens.<br /><br /><div class='alert alert-warning bg-white border-0 mb-0 pb-0' role='alert'>Preset your highest bid below:</div>`"
                    data-noicon="true"
                    :data-value="
                      this.$options.filters.formatDecimalNoGroup(
                        auction.originalPrice / 2
                      )
                    "
                  >
                    <input
                      type="hidden"
                      name="_token"
                      :value="getCsrfToken()"
                    />
                    <button
                      type="submit"
                      class="btn btn-md btn-link p-0 text-white"
                    >
                      Seat price:
                      {{ seats[seats.length - 1].tokenPrice | formatNumber }}
                      tokens (OPTIONAL)
                    </button>
                  </form>
                  <div v-else class="d-flex align-items-center small">
                    Seat price:
                    {{ seats[seats.length - 1].tokenPrice | formatNumber }}
                    tokens (OPTIONAL)
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-end">
          <span class="text-muted small font-weight-bold">
            Each token is ${{ tokenValue }}
          </span>
        </div>
      </div>
      <!-- End .product-single-details -->
    </div>
    <div class="row">
      <div class="col-md-7 offset-md-5">
        <hr class="divider my-1" />
        <small v-if="auction.watchers > 1">
          {{ auction.watchers }} users are watching
        </small>
        <small v-else-if="auction.watchers > 0">
          {{ auction.watchers }} user is watching
        </small>
        <!-- End .product single-share -->
      </div>
    </div>
    <div class="product-single-tabs pb-3 mb-1">
      <ul class="nav nav-tabs" role="tablist">
        <li
          class="nav-item"
          v-if="auction.specifications && auction.specifications.length > 0"
        >
          <a
            class="nav-link active"
            id="product-tab-specs"
            data-toggle="tab"
            href="#product-specs-content"
            role="tab"
            aria-controls="product-specs-content"
            aria-selected="true"
            >Specifications</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            id="product-tab-desc"
            data-toggle="tab"
            href="#product-desc-content"
            role="tab"
            aria-controls="product-desc-content"
            aria-selected="false"
            >Description</a
          >
        </li>
      </ul>
      <div class="tab-content">
        <div
          class="tab-pane fade show active"
          id="product-specs-content"
          role="tabpanel"
          aria-labelledby="product-tab-specs"
          v-if="auction.specifications && auction.specifications.length > 0"
        >
          <div class="product-desc-content">
            <table class="table table-sm table-striped">
              <tbody>
                <tr v-for="spec in auction.specifications" v-bind:key="spec.id">
                  <th class="w-25">{{ spec.key }}</th>
                  <td class="w-75">{{ spec.value }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- End .product-desc-content -->
        </div>
        <!-- End .tab-pane -->

        <div
          class="tab-pane fade"
          id="product-desc-content"
          role="tabpanel"
          aria-labelledby="product-tab-desc"
        >
          <div
            class="product-desc-content"
            v-html="auction.description"
            style="white-space: pre-wrap"
          ></div>
          <!-- End .product-desc-content -->
        </div>
        <!-- End .tab-pane -->
      </div>
      <!-- End .tab-content -->
    </div>
  </div>
  <!-- End .product-single-container -->
</template>

<script>
export default {
  props: {
    auction: {
      required: true,
    },
    seats: {
      required: true,
    },
  },
  data: function () {
    return {
      auctionCountdownKey: 0,
      authenticated: window.authenticated,
      userId: window.userId,
      tokenValue: window.tokenValue,
    };
  },
  methods: {
    auctionStatusText: function (status) {
      if (status === "Completed") {
        return "Auction Ended";
      } else if (status === "InProgress") {
        return "Auction Started";
      } else if (status === "Canceled") {
        return "Auction Canceled";
      }
    },
    countdownStyle: function (secondsLeft) {
      if (secondsLeft > 86400) {
        return " bg-purple";
      }
      if (secondsLeft > 3600) {
        return " bg-orange";
      }
      if (secondsLeft > 240) {
        return " bg-red";
      }
      return " bg-red countdown-flash";
    },
    countdownTextStyle: function (secondsLeft) {
      if (secondsLeft > 86400) {
        return " text-purple";
      }
      if (secondsLeft > 3600) {
        return " text-orange";
      }
      if (secondsLeft > 240) {
        return " text-red";
      }
      return " text-red countdown-flash";
    },
    getCsrfToken: function () {
      return document.querySelector('meta[name="csrf-token"]').content;
    },
  },
  watch: {
    "auction.current_round_price": function (newVal, oldVal) {
      const vm = this;
      if (!!vm.$refs.currentPrice) {
        vm.$refs.currentPrice.classList.add("flash");
        setTimeout(function () {
          vm.$refs.currentPrice.classList.remove("flash");
        }, 2000);
      }
    },
    "auction.start_time": function (newVal, oldVal) {
      const vm = this;
      if (!!vm.$refs.auctionCountdown) {
        this.auctionCountdownKey += 1;
      }
    },
  },
};
</script>
